import type { ReactNode } from "react";
import clsx from "clsx";

type Tone = "neutral" | "sage" | "warn" | "danger" | "clay";

// warn/clay use `text-ink` rather than `text-warn`/`text-clay` on their own
// `-dim` background: measured contrast is ~3.98:1 and ~3.48:1 respectively,
// short of the 4.5:1 AA text threshold (sage/danger's own tones already
// clear it, ~4.7:1 and ~5.1:1). The tinted background still carries the
// tone; only the text color changes, and the shared tokens are untouched.
const TONE_CLASSES: Record<Tone, string> = {
  neutral: "bg-paper-dim text-ink-soft",
  sage: "bg-sage-dim text-sage-strong",
  warn: "bg-warn-dim text-ink",
  danger: "bg-danger-dim text-danger",
  clay: "bg-clay-dim text-ink",
};

export function Pill({ tone = "neutral", children }: { tone?: Tone; children: ReactNode }) {
  return (
    <span className={clsx("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium", TONE_CLASSES[tone])}>
      {children}
    </span>
  );
}
